import { Fragment } from "react";

import SkipLink from "../_kit/SkipLink";
import Hero from "./Hero";
import Header from "./Header";
import GuestWidget from "./GuestWidget";
import Footer from "./Footer";
import BookingWidget from "./BookingWidget";
import BookingPanel from "./BookingPanel";
import {
  useLandingLanguage,
  LandingLanguageProvider,
} from "../../../contexts/landing-language";

/* "/hebe" — the booking page.
 *
 * About, facilities, rooms and the gallery moved to /hebe/about. A guest who searched for somewhere
 * to stay in Bogor should meet a date field and a price, not the property's whole story; the story
 * is one click away for the people who want it.
 */
const HomeContent = () => {
  const { t } = useLandingLanguage();

  return (
    <Fragment>
      <SkipLink href="#main">{t.hero.scrollHint}</SkipLink>
      <Header />
      <main id="main">
        <Hero />
        <BookingPanel />
        {/* OTAs sit BELOW the direct booking module: they are where else you can find us, not the
         * first thing we ask a guest to do. */}
        <BookingWidget />
      </main>
      <Footer />
      <GuestWidget />
    </Fragment>
  );
};

const UnnamedComponent = () => (
  <LandingLanguageProvider>
    {/* The head is server-rendered from Hebe::SeoPresenter via shared/_page_seo — see the note in
        the git history for why it is not an Inertia <Head>. */}
    <HomeContent />
  </LandingLanguageProvider>
);

export default UnnamedComponent;
